import Service from "../component/service"

function Servicesdrop(){
    return(
        <>
        <Service/>
        </>
    )
}
export default Servicesdrop